import React, { useState, useEffect, useReducer } from 'react';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { insertPresupuesto } from "../../../Api/presupuesto";
import { getAllCostos } from "../../../Api/Costos";
import { getAllCondiciones } from "../../../Api/AdminApi";
import { getAllClientes, saveCliente, isClienteDuplicado } from "../../../Api/cliente";
import ModalAgregarClientes from "../sis/ModalFacturacion/ModalAgregarCliente.js";
import { Modal, Spinner } from "react-bootstrap";
import { pdf } from "@react-pdf/renderer";
import CombinedPDF from "./CombinedPDF";

// =====================
// Uppercase helpers
// =====================
function toUpperCaseTextPreservingHtml(str) {
  if (typeof str !== 'string') return str;
  let result = str.replace(/([^<>]+)(?=<|$)/g, (match) => match.toUpperCase());
  result = result.replace(/&NBSP;/gi, '&nbsp;');
  return result;
}
function toUpperCaseObject(obj) {
  if (typeof obj !== 'object' || obj === null) {
    if (typeof obj === 'string') {
      return toUpperCaseTextPreservingHtml(obj);
    }
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(toUpperCaseObject);
  }
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      toUpperCaseObject(value)
    ])
  );
}

const customSelectStyles = {
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  control: (provided) => ({ ...provided, width: '100%' }),
};

const initialModalState = { isShow: false };
const modalReducer = (state, action) => {
  switch (action.type) {
    case 'SHOW_MODAL': return { ...state, isShow: true };
    case 'HIDE_MODAL': return { ...state, isShow: false };
    default: return state;
  }
};

const PresupuestoForm = () => {
  const initialPresupuestoState = {
    subtotal: 0, descuento: 0, total: 0, obs: '',
    validohasta: '', fecha: new Date().toISOString().slice(0, 10),
    idcliente: null, nombre_cliente: '', direccion_cliente: '',
    telefono_cliente: '', correo_cliente: '', ciudad_cliente: '',
    asesor: '', averagePrice: "", itemsPresupuestos: [], condiciones: []
  };
  const initialItemState = {
    codigo: '', descripcion: '', cantidad: 0, precio: 0, subtotal: 0, descuento: 0, total: 0
  };
  const Editdata = [{
    nombre: "", razonsocial: "", ruc: "", Ciudad: "", direccion: "", telefono: "", correo: ""
  }];

  const [presupuesto, setPresupuesto] = useState(initialPresupuestoState);
  const [pdfTipo, setPdfTipo] = useState("enfermeria"); // radio
  const [item, setItem] = useState(initialItemState);
  const [condicion, setCondicion] = useState(null);
  const [listCostos, setListCostos] = useState([]);
  const [listCondiciones, setListCondiciones] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [listClientes, setListClientes] = useState([]);
  const [reducer, dispatch] = useReducer(modalReducer, initialModalState);
  const [showAverage, setShowAverage] = useState(false);
  const [averagePrice, setAveragePrice] = useState("");
  const [showLoadingPDF, setShowLoadingPDF] = useState(false);
  const [clienteError, setClienteError] = useState(""); // NEW
  const [isSubmitting, setIsSubmitting] = useState(false);
  // =========================
  // Load data
  // =========================


  useEffect(() => {
    const fetchCostos = async () => {
      try {
        const listResult6 = await getAllCostos();
        const mapeoCostos = listResult6.map((item) => ({
          value: item.idcostos,
          label: item.COD + " " + item.producto,
          COD: item.COD,
          precioventa: item.precioventa
        }));
        setListCostos(mapeoCostos);
      } catch (error) { console.error('Error fetching costos:', error); }
    };

    const fetchCondiciones = async () => {
      try {
        const listResultCond = await getAllCondiciones();
        const mapeoCondiciones = listResultCond.result.map((item) => ({
          value: item.cod,
          label: item.condicion,
          cod: item.cod,
          condicion: item.condicion
        }));
        setListCondiciones(mapeoCondiciones);
      } catch (error) { console.error('Error fetching condiciones:', error); }
    };

    const fetchClientes = async () => {
      try {
        const listResult3 = await getAllClientes();
        const resultMapeado2 = listResult3.map((item) => ({
          label: `${item.nombre} ${item.ruc}`,
          value: item.idClientes,
          nombre: item.nombre,
          direccion: item.direccion || '',
          telefono: item.telefono || '',
          correo: item.Correo || '',
          ciudad: item.Ciudad || ''
        }));
        setListClientes(resultMapeado2);
      } catch (error) { console.error('Error fetching clientes:', error); }
    };

    fetchCostos();
    fetchCondiciones();
    fetchClientes();
  }, []);

  // =========================
  // Handlers
  // =========================
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Si es campo de cliente y no hay cliente seleccionado, no permitir
    if (
      ["nombre_cliente", "direccion_cliente", "telefono_cliente", "correo_cliente", "ciudad_cliente"].includes(name) &&
      (presupuesto.idcliente === null || presupuesto.idcliente === undefined)
    ) {
      setClienteError("Seleccione cliente antes de modificar los datos.");
      return;
    }
    setClienteError(""); // limpia error si edita campo válido
    setPresupuesto(prev => ({
      ...prev,
      [name]: typeof value === "string" ? toUpperCaseTextPreservingHtml(value) : value
    }));
  };

  const handleClientSelect = (selectedOption) => {
    setClienteError("");
    setSelectedClient(selectedOption); // <--- agrega esto
    setPresupuesto(prev => ({
      ...prev,
      idcliente: selectedOption ? selectedOption.value : null,
      nombre_cliente: selectedOption ? toUpperCaseTextPreservingHtml(selectedOption.nombre) : '',
      direccion_cliente: selectedOption ? toUpperCaseTextPreservingHtml(selectedOption.direccion) : '',
      telefono_cliente: selectedOption ? toUpperCaseTextPreservingHtml(selectedOption.telefono) : '',
      correo_cliente: selectedOption ? toUpperCaseTextPreservingHtml(selectedOption.correo) : '',
      ciudad_cliente: selectedOption ? toUpperCaseTextPreservingHtml(selectedOption.ciudad) : ''
    }));
  };
  const handleItemChange = (e) => {
    const { name, value } = e.target;
    setItem(prev => {
      const updatedItem = { ...prev, [name]: typeof value === "string" ? toUpperCaseTextPreservingHtml(value) : value };
      const cantidad = Math.max(parseFloat(updatedItem.cantidad) || 0, 0);
      const precio = parseFloat(updatedItem.precio) || 0;
      const descuento = parseFloat(updatedItem.descuento) || 0;
      updatedItem.cantidad = cantidad;
      updatedItem.subtotal = Math.round(cantidad * precio);
      updatedItem.total = Math.round(updatedItem.subtotal * (1 - descuento / 100));
      return updatedItem;
    });
  };

  const handleSelectChange = (selectedOption) => {
    setItem(prev => {
      const updatedItem = {
        ...prev,
        descripcion: selectedOption ? toUpperCaseTextPreservingHtml(selectedOption.label.split(' ').slice(1).join(' ')) : '',
        codigo: selectedOption ? toUpperCaseTextPreservingHtml(selectedOption.COD) : '',
        precio: selectedOption ? parseFloat(selectedOption.precioventa) || 0 : 0
      };
      const cantidad = Math.max(parseFloat(updatedItem.cantidad) || 0, 0);
      const precio = parseFloat(updatedItem.precio) || 0;
      const descuento = parseFloat(updatedItem.descuento) || 0;
      updatedItem.cantidad = cantidad;
      updatedItem.subtotal = Math.round(cantidad * precio);
      updatedItem.total = Math.round(updatedItem.subtotal * (1 - descuento / 100));
      return updatedItem;
    });
  };

  const handleCondicionChange = (selectedOption) => { setCondicion(selectedOption); };

  const addItem = () => {
    const { descripcion, cantidad, precio, descuento } = item;

    // Validaciones
    const esNumeroEntero = (n) => Number.isInteger(Number(n));
    const esNumeroPositivo = (n) => !isNaN(n) && Number(n) > 0;

    if (
      !descripcion ||
      !esNumeroEntero(cantidad) || Number(cantidad) <= 0 ||
      !esNumeroEntero(precio) || Number(precio) <= 0 ||
      isNaN(descuento) || Number(descuento) < 0 || Number(descuento) > 100
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'Datos inválidos',
        text: 'Complete todos los campos correctamente.\n- Cantidad y precio deben ser números enteros mayores a 0.\n- El descuento debe ser un número entre 0 y 100.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: "#00273a",
      });
      return;
    }

    setPresupuesto(prev => {
      const newItems = [
        ...prev.itemsPresupuestos,
        {
          ...item,
          cantidad: Number(cantidad),
          precio: Number(precio),
          descuento: Number(descuento),
          idpresupuestos: prev.itemsPresupuestos.length + 1
        }
      ];

      const newSubtotal = Math.round(newItems.reduce((sum, i) => sum + i.subtotal, 0));
      const newTotal = Math.round(newItems.reduce((sum, i) => sum + i.total, 0));
      const newDescuento = Math.round(newSubtotal - newTotal);

      return {
        ...prev,
        itemsPresupuestos: newItems,
        subtotal: newSubtotal,
        descuento: newDescuento,
        total: newTotal
      };
    });

    setItem(initialItemState);
  };

  const deleteItem = (index) => {
    setPresupuesto(prev => {
      const newItems = prev.itemsPresupuestos.filter((_, i) => i !== index);
      const newSubtotal = Math.round(newItems.reduce((sum, i) => sum + i.subtotal, 0));
      const newTotal = Math.round(newItems.reduce((sum, i) => sum + i.total, 0));
      const newDescuento = Math.round(newSubtotal - newTotal);
      return {
        ...prev,
        itemsPresupuestos: newItems,
        subtotal: newSubtotal,
        descuento: newDescuento,
        total: newTotal
      };
    });
  };

  const addCondicion = () => {
    if (condicion) {
      setPresupuesto(prev => ({
        ...prev,
        condiciones: [...prev.condiciones, {
          condicion: toUpperCaseTextPreservingHtml(condicion.condicion)
        }]
      }));
      setCondicion(null);
    }
  };
  const deleteCondicion = (index) => {
    setPresupuesto(prev => ({
      ...prev,
      condiciones: prev.condiciones.filter((_, i) => i !== index)
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;
    setIsSubmitting(true);

    if (!presupuesto.idcliente) {
      setClienteError("Seleccione un cliente antes de generar el presupuesto.");
      Swal.fire({
        icon: 'warning',
        title: 'Seleccione cliente',
        text: 'Debe seleccionar un cliente antes de continuar.',
        confirmButtonColor: "#00273a",
      });
      setIsSubmitting(false);
      return;
    }

    setClienteError("");

    try {
      const presupuestoUpper = toUpperCaseObject(presupuesto);
      const response = await insertPresupuesto(presupuestoUpper);

      await Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Presupuesto guardado con éxito!',
        confirmButtonColor: "#00273a",
      });

      const idp = response.idPresupuesto;

      // 🔵 Esperamos que el PDF se genere y descargue ANTES de limpiar el formulario
      await handleGenerarPDF(
        { ...presupuestoUpper, idpresupuestos: idp },
        idp
      );

      // 🔵 Ahora sí limpiamos el formulario
      setPresupuesto(initialPresupuestoState);
      setItem(initialItemState);
      setCondicion(null);
      setSelectedClient(null);
      setShowAverage(false);
      setAveragePrice("");

    } catch (error) {
      console.error('Error al guardar el presupuesto:', error);
      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `Error al guardar el presupuesto: ${error}`,
        confirmButtonColor: "#00273a",
      });
    } finally {
      setIsSubmitting(false);
    }
  };


  const openModal = () => { dispatch({ type: 'SHOW_MODAL' }); };
  const onCloseModal = () => { dispatch({ type: 'HIDE_MODAL' }); };

  const onReturnDataCliente = async (data, setIsButtonDisabled) => {
    try {
      const dataUpper = toUpperCaseObject(data);
      const duplicate = await isClienteDuplicado({
        telefono: dataUpper.telefono,
        nombre: dataUpper.nombre,
        ruc: dataUpper.ruc,
      });

      if (duplicate.isDuplicate) {
        const { isConfirmed } = await Swal.fire({
          icon: "warning",
          title: "Cliente duplicado",
          text: `El campo ${duplicate.field} ya existe. ¿Desea continuar?`,
          confirmButtonText: "Sí, guardar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          confirmButtonColor: "#00273a",
          cancelButtonColor: "#d33",
        });

        setIsButtonDisabled(false); // Re-enable button after duplicate alert
        if (!isConfirmed) return; // Cancelled
      }

      const result = await saveCliente({ ...dataUpper, isNew: true });
      const newClient = {
        label: `${dataUpper.nombre} ${dataUpper.ruc}`,
        value: result.idClientes,
        nombre: dataUpper.nombre,
        direccion: dataUpper.direccion || '',
        telefono: dataUpper.telefono || '',
        correo: dataUpper.correo || '',
        ciudad: dataUpper.Ciudad || '',
        idcliente: result.idcliente,
      };

      setListClientes(prev => [...prev, newClient]);
      setPresupuesto(prev => ({
        ...prev,
        idcliente: newClient.idcliente,
        nombre_cliente: newClient.nombre,
        direccion_cliente: newClient.direccion,
        telefono_cliente: newClient.telefono,
        correo_cliente: newClient.correo,
        ciudad_cliente: newClient.ciudad,
      }));
      setSelectedClient(newClient);
      dispatch({ type: 'HIDE_MODAL' });

      await Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Cliente agregado con éxito!',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: "#00273a",
      });
    } catch (error) {
      console.error('Error saving cliente:', error);
      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `Error al guardar el cliente: ${error}`,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: "#00273a",
      });
    } finally {
      setIsButtonDisabled(false); // Re-enable button after success/error alert
    }
  };

  const handleAveragePriceChange = (e) => {
    const value = e.target.value;
    const newValue = value === "" ? "" : Math.max(parseFloat(value) || 0, 0);
    setAveragePrice(newValue);
    setPresupuesto(prev => ({
      ...prev,
      averagePrice: newValue
    }));
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setShowAverage(isChecked);
    if (!isChecked) {
      setAveragePrice("");
      setPresupuesto(prev => ({
        ...prev,
        averagePrice: ""
      }));
    }
  };
  const handleGenerarPDF = async (presupuestoData, idp) => {
    try {
      setShowLoadingPDF(true);

      const blob = await pdf(
        <CombinedPDF
          tipo={pdfTipo}
          presupuesto={presupuestoData}
          items={presupuesto.itemsPresupuestos}
          condiciones={presupuesto.condiciones}
          subtotal={presupuesto.subtotal}
          total={presupuesto.total}
          descuento={presupuesto.descuento}
          averagePrice={presupuesto.averagePrice}
        />
      ).toBlob();


      const url = URL.createObjectURL(blob);

      const clienteLimpio = (presupuestoData.nombre_cliente || "")
        .replace(/[^a-zA-Z0-9_ÁÉÍÓÚÑáéíóúñ ]/g, "")
        .replace(/\s+/g, "_");

      const tipoNombre =
        pdfTipo === "enfermeria" ? "Enfermeria" : "Cuidador";

      const fileName = `Cotizacion_${idp}_${tipoNombre}_${clienteLimpio}.pdf`;

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
    } catch (error) {
      console.error("Error generando PDF combinado:", error);
    } finally {
      setShowLoadingPDF(false);
    }
  };

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input[type=number] {
      -moz-appearance: textfield;
    }
  `;
    document.head.appendChild(style);
    return () => { document.head.removeChild(style); };
  }, []);

  // =========================
  // RENDER
  // =========================
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <div className="card p-4 p-xl-5 my-3 my-xl-4">
            <h2 className="fw-bold mb-4">Nuevo Presupuesto</h2>
            <hr className="my-4" />

            {/* Datos Cliente */}
            <div className="d-flex align-items-center mb-4">
              <h3 className="fw-bold me-2">Datos del Cliente</h3>
              <button
                type="button"
                onClick={openModal}
                className="btn btn-primary btn-sm ms-2"
              >
                Agregar Cliente
              </button>
            </div>
            <div className="row mb-2">
              <div className="col-lg-6 col-md-8 col-sm-12">
                <Select
                  options={listClientes}
                  value={selectedClient} // <--- agrega esto
                  onChange={handleClientSelect}
                  placeholder="Buscar cliente por nombre o RUC..."
                  styles={customSelectStyles}
                  menuPortalTarget={document.body}
                  isClearable
                />
                {clienteError && (
                  <div className="text-danger mt-2">{clienteError}</div>
                )}
              </div>
            </div>
            {reducer.isShow && (
              <ModalAgregarClientes
                estado={reducer.isShow}
                onCloseModal={onCloseModal}
                onReturnValue={onReturnDataCliente}
                Editdata={Editdata}
              />
            )}
            <div className="row mb-5">
              <div className="col-lg-4 col-md-4 col-sm-4">
                <div className="d-flex flex-row align-items-center mb-2">
                  <span className="fw-bold me-2">Nombre: </span>
                  <input
                    type="text"
                    name="nombre_cliente"
                    value={presupuesto.nombre_cliente}
                    onChange={handleInputChange}
                    placeholder="Nombre del Cliente"
                    className="form-control"
                    required
                    disabled={presupuesto.idcliente === null || presupuesto.idcliente === undefined}
                  />
                </div>
                <div className="d-flex flex-row align-items-center mb-2">
                  <span className="fw-bold me-2">Dirección: </span>
                  <input
                    type="text"
                    name="direccion_cliente"
                    value={presupuesto.direccion_cliente}
                    onChange={handleInputChange}
                    placeholder="Dirección"
                    className="form-control"
                    maxLength={80}
                    disabled={presupuesto.idcliente === null || presupuesto.idcliente === undefined}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4">
                <div className="d-flex flex-row align-items-center mb-2">
                  <span className="fw-bold me-2">Teléfono: </span>
                  <input
                    type="text"
                    name="telefono_cliente"
                    value={presupuesto.telefono_cliente}
                    onChange={handleInputChange}
                    placeholder="Teléfono"
                    className="form-control"
                    maxLength={15}
                    disabled={presupuesto.idcliente === null || presupuesto.idcliente === undefined}
                  />
                </div>
                <div className="d-flex flex-row align-items-center mb-2">
                  <span className="fw-bold me-2">Correo: </span>
                  <input
                    type="email"
                    name="correo_cliente"
                    value={presupuesto.correo_cliente}
                    onChange={handleInputChange}
                    placeholder="Correo"
                    className="form-control"
                    disabled={presupuesto.idcliente === null || presupuesto.idcliente === undefined}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4">
                <div className="d-flex flex-row align-items-center mb-2">
                  <span className="fw-bold me-2">Ciudad: </span>
                  <input
                    type="text"
                    name="ciudad_cliente"
                    value={presupuesto.ciudad_cliente}
                    onChange={handleInputChange}
                    placeholder="Ciudad"
                    className="form-control"
                    maxLength={50}
                    disabled={presupuesto.idcliente === null || presupuesto.idcliente === undefined}
                  />
                </div>
              </div>
            </div>
            <hr className="my-4" />

            {/* Datos Presupuesto */}
            <h3 className="fw-bold mb-4">Datos del Presupuesto</h3>
            <div className="row mb-5">
              <div className="col-lg-6 col-md-8 col-sm-12">
                <div className="mb-3">
                  <label className="fw-bold me-2" htmlFor="fecha">Fecha:</label>
                  <input
                    type="date"
                    id="fecha"
                    name="fecha"
                    value={presupuesto.fecha}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label className="fw-bold me-2" htmlFor="validohasta">Válido Hasta:</label>
                  <input
                    type="date"
                    id="validohasta"
                    name="validohasta"
                    value={presupuesto.validohasta}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label className="fw-bold me-2" htmlFor="asesor">Asesor:</label>
                  <input
                    type="text"
                    name="asesor"
                    value={presupuesto.asesor}
                    onChange={handleInputChange}
                    placeholder="Asesor"
                    className="form-control"
                    maxLength={50}
                  />
                </div>
                <div className="mb-3">
                  <label className="fw-bold me-2" htmlFor="obs">Observaciones:</label>
                  <textarea
                    id="obs"
                    name="obs"
                    value={presupuesto.obs}
                    onChange={handleInputChange}
                    placeholder="Observaciones"
                    className="form-control"
                    rows="3"
                  />
                </div>
              </div>
            </div>
            <hr className="my-4" />

            {/* Items */}
            <h3 className="fw-bold mb-4">Items del Presupuesto</h3>
            <div className="row mb-5">
              <div className="col">
                <div style={{ overflowX: "auto", position: "relative" }}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th style={{ color: "black", width: "15%" }}>Código</th>
                        <th style={{ color: "black", width: "39%" }}>Descripción</th>
                        <th style={{ color: "black", width: "12%" }}>Cantidad</th>
                        <th style={{ color: "black", width: "6%" }}>Precio</th>
                        <th style={{ color: "black", width: "6%" }}>Subtotal</th>
                        <th style={{ color: "black", width: "12%" }}>Des.(%)</th>
                        <th style={{ color: "black", width: "8%" }}>Total</th>
                        <th style={{ color: "black", width: "5%" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{item.codigo}</td>
                        <td style={{ position: "relative" }}>
                          <Select
                            className="mt-2"
                            options={listCostos}
                            name="descripcion"
                            value={listCostos.find(option => toUpperCaseTextPreservingHtml(option.label.split(' ').slice(1).join(' ')) === item.descripcion && toUpperCaseTextPreservingHtml(option.COD) === item.codigo) || null}
                            onChange={handleSelectChange}
                            placeholder="Seleccione una descripción"
                            styles={customSelectStyles}
                            menuPortalTarget={document.body}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            name="cantidad"
                            value={item.cantidad}
                            onChange={handleItemChange}
                            placeholder="Cantidad"
                            className="form-control"
                            min="0"
                          />
                        </td>
                        <td>{item.precio}</td>
                        <td><span>{item.subtotal}</span></td>
                        <td>
                          <input
                            type="number"
                            name="descuento"
                            value={item.descuento}
                            onChange={handleItemChange}
                            placeholder="(%)"
                            className="form-control"
                            min="0"
                            max="100"
                          />
                        </td>
                        <td><span>{item.total}</span></td>
                        <td>
                          <button
                            type="button"
                            onClick={addItem}
                            className="btn btn-primary btn-sm"
                          >
                            +
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="8">
                          <hr style={{ borderWidth: "2px", margin: "0" }} />
                        </td>
                      </tr>
                      {presupuesto.itemsPresupuestos.map((item, index) => (
                        <tr key={index}>
                          <td>{item.codigo}</td>
                          <td style={{ whiteSpace: 'normal', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {item.descripcion}
                          </td>
                          <td>{item.cantidad}</td>
                          <td>{item.precio}</td>
                          <td>{item.subtotal}</td>
                          <td>{item.descuento}%</td>
                          <td>{item.total}</td>
                          <td>
                            <button
                              type="button"
                              onClick={() => deleteItem(index)}
                              className="btn btn-danger btn-sm"
                            >
                              -
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex flex-row justify-content-end mt-2">
                  <div className="me-5">
                    <span className="fw-bold">Subtotal (vista previa): </span>
                    <span>{item.subtotal}</span>
                  </div>
                  <div>
                    <span className="fw-bold">Total (vista previa): </span>
                    <span>{item.total}</span>
                  </div>
                </div>
                <div className="mt-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      id="showAverage"
                      checked={showAverage}
                      onChange={handleCheckboxChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label fw-bold me-2" htmlFor="showAverage">
                      Mostrar Precio Enfermeria por Hora
                    </label>
                  </div>
                  <div className="d-flex flex-row align-items-center">
                    <span className="fw-bold me-2">Precio por hora: </span>
                    <input
                      type="text"
                      value={averagePrice}
                      onChange={e => {
                        // Permite solo valores numéricos
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) { // Solo números enteros positivos
                          handleAveragePriceChange({ target: { value } });
                        }
                      }}
                      disabled={!showAverage}
                      className="form-control"
                      style={{ width: '100px' }}
                      min="0"
                      placeholder="0"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr className="my-4" />

            {/* Condiciones */}
            <h3 className="fw-bold mb-4">Condiciones</h3>
            <div className="row mb-5">
              <div className="col">
                <div className="d-flex flex-row align-items-center mb-3">
                  <div style={{ width: '80%' }}>
                    <Select
                      className="mt-2 me-2"
                      options={listCondiciones}
                      value={condicion}
                      onChange={handleCondicionChange}
                      placeholder="Seleccione una condición"
                      styles={customSelectStyles}
                      menuPortalTarget={document.body}
                      formatOptionLabel={(option) => (
                        <div>
                          <div style={{ fontWeight: "bold", fontSize: "1.05rem", marginBottom: 2 }}>
                            {option.cod}
                          </div>
                          <div
                            style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                            dangerouslySetInnerHTML={{ __html: option.condicion }}
                          />
                        </div>
                      )}
                    />
                  </div>
                  <button
                    type="button"
                    onClick={addCondicion}
                    className="btn btn-primary btn-sm"
                  >
                    Agregar Condición
                  </button>
                </div>
                <div style={{ overflowX: "auto" }}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th style={{ color: "black", width: "95%" }}>Condiciones</th>
                        <th style={{ color: "black", width: "5%" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {presupuesto.condiciones.map((cond, index) => (
                        <tr key={index}>
                          <td
                            style={{
                              width: "95%",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                            }}
                          >
                            <span dangerouslySetInnerHTML={{ __html: cond.condicion }} />
                          </td>
                          <td>
                            <button
                              type="button"
                              onClick={() => deleteCondicion(index)}
                              className="btn btn-danger btn-sm"
                            >
                              -
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <hr className="my-4" />

            {/* Totales */}
            <h3 className="fw-bold mb-4">Totales</h3>
            <div className="row mb-5 justify-content-start">
              <div className="col-lg-6">
                <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                  <span className="fw-bold">Subtotal:</span>
                  <span>{presupuesto.subtotal}</span>
                </div>
                <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                  <span className="fw-bold">Descuento:</span>
                  <span>{presupuesto.descuento}</span>
                </div>
                <div className="d-flex flex-row align-items-start justify-content-between mt-2" style={{ fontSize: "1.125rem" }}>
                  <span className="fw-bold">Total:</span>
                  <span className="fw-bold">{presupuesto.total}</span>
                </div>
              </div>
            </div>
            <hr className="my-4" />
            <div className="mb-4">
              <h5 className="fw-bold">Tipo de PDF</h5>

              <div className="d-flex gap-4">
                <label className="d-flex align-items-center">
                  <input
                    type="radio"
                    value="enfermeria"
                    checked={pdfTipo === "enfermeria"}
                    onChange={(e) => setPdfTipo(e.target.value)}
                    className="form-check-input me-2"
                  />
                  Enfermería
                </label>

                <label className="d-flex align-items-center">
                  <input
                    type="radio"
                    value="cuidador"
                    checked={pdfTipo === "cuidador"}
                    onChange={(e) => setPdfTipo(e.target.value)}
                    className="form-check-input me-2"
                  />
                  Cuidador
                </label>
                  <label className="d-flex align-items-center">
                  <input
                    type="radio"
                    value="Solo Presupuesto"
                    checked={pdfTipo === "solo"}
                    onChange={(e) => setPdfTipo(e.target.value)}
                    className="form-check-input me-2"
                  />
                  Solo Presupuesto
                </label>
              </div>
            </div>


            {/* Submit Button */}
            <button
              type="button"
              onClick={handleSubmit}
              className="btn btn-primary d-block w-100 mb-3"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Guardando...' : 'Generar Presupuesto'}
            </button>
          </div>
        </div>
      </div>
      <Modal show={showLoadingPDF} backdrop="static" keyboard={false} centered>
        <Modal.Body className="text-center py-4">
          <Spinner animation="border" role="status" className="mb-3" />
          <h5>Generando PDF...</h5>
          <p>Por favor, espere un momento.</p>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PresupuestoForm;